'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserVoipExtension } from '../../Entities/User/UserVoipExtension';
import { UserVoipExtensionCollection } from '../../Collections/User/UserVoipExtensionCollection';

export class UserVoipExtensionRepository extends CoreRepository {
  public createUserVoipExtensions(userId: number, payload: object = {}) {
    return this.webAPI.createUserVoipExtensions(userId, payload).then((response) => {
      return response;
    });
  }

  public getUserVoipExtensions(userId: number, provider: number, options: object = {}) {
    return this.webAPI.getUserVoipExtensions(userId, provider, options).then((response) => {
      const collection = new UserVoipExtensionCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserVoipExtension();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
